import Swiper, { Navigation, Pagination, EffectCreative, Autoplay, Parallax } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.reviews-slider', {
    modules: [Navigation, Pagination, EffectCreative, Autoplay, Parallax],
    effect: 'slide',
    loop: true,
    speed: 1000,
    slidesPerView: 1.2,
    spaceBetween: 30,
    centeredSlides: true,
    creativeEffect: {
        prev: {
            // will set `translateZ(-400px)` on previous slides
            translate: [0, 0, -400],
        },
        next: {
            // will set `translateX(100%)` on next slides
            translate: ['100%', 0, 0],
        },
    },
    breakpoints: {
      968: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
    },
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
